import { useSelector, useDispatch, batch } from 'react-redux'
import { RootState } from '../reducers/rootReducer';

import { SET_ERROR, SET_WARNING_WIDTH, SET_WARNING_HEIGHT } from '../constants/validatorConstants';

export default function ValidatorActions() {
   const dispatch = useDispatch();

   const error = useSelector((state: RootState) => state.validatorReducer.error);
   const warningWidth = useSelector((state: RootState) => state.validatorReducer.warningWidth);
   const warningHeight = useSelector((state: RootState) => state.validatorReducer.warningHeight);

   const setError: Function = (error: string) => {
      dispatch({ type: SET_ERROR, error: error});
   }

   const clearError: Function = () => {
      dispatch({ type: SET_ERROR, error: null });
   }

   const setWarningWidth: Function = (warningWidth: string) => {
      dispatch({ type: SET_WARNING_WIDTH, warningWidth: warningWidth });
   }
   
   const setWarningHeight: Function = (warningHeight: string) => {
      dispatch({ type: SET_WARNING_HEIGHT, warningHeight: warningHeight });
   }

   const clearValidationInfo: Function = () => {
      dispatch({ type: SET_ERROR, error: null });
      dispatch({ type: SET_WARNING_WIDTH, warningWidth: null });
      dispatch({ type: SET_WARNING_HEIGHT, warningHeight: null });
   }

   return { error, setError, clearError, warningWidth, warningHeight, setWarningWidth, setWarningHeight, clearValidationInfo }
}

